import type { SvgPathProps } from '../Icon';

const Instagram: React.FC<SvgPathProps> = ({ isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <g>
      <path d="M40.339 34.885a5.642 5.642 0 01-5.636 5.635H13.882a5.642 5.642 0 01-5.635-5.635v-20.82a5.642 5.642 0 015.635-5.637h20.82a5.642 5.642 0 015.637 5.636v20.821zM34.703 7.13H13.882c-3.824 0-6.936 3.11-6.936 6.935v20.821c0 3.824 3.112 6.935 6.936 6.935h20.82c3.825 0 6.938-3.11 6.938-6.935v-20.82c0-3.826-3.113-6.936-6.937-6.936z" />
      <path d="M24.012 33.013c-4.392 0-7.963-3.572-7.963-7.963s3.572-7.964 7.963-7.964c4.39 0 7.962 3.573 7.962 7.964 0 4.39-3.572 7.963-7.962 7.963m0-17.227c-5.107 0-9.264 4.156-9.264 9.264s4.157 9.263 9.264 9.263c5.107 0 9.264-4.155 9.264-9.263s-4.158-9.264-9.265-9.264m10.38-3.165a1.767 1.767 0 100 3.533 1.767 1.767 0 000-3.533" />
    </g>
  );

  const normalHover = (
    <g>
      <path d="M40.045 34.885a5.64 5.64 0 01-5.635 5.635H13.59a5.642 5.642 0 01-5.636-5.635v-20.82a5.642 5.642 0 015.635-5.637H34.41a5.641 5.641 0 015.635 5.636v20.821zM34.41 7.13H13.59c-3.825 0-6.937 3.11-6.937 6.935v20.821c0 3.824 3.112 6.935 6.936 6.935H34.41c3.824 0 6.936-3.11 6.936-6.935v-20.82c0-3.826-3.112-6.936-6.936-6.936z" />
      <path d="M23.72 33.013c-4.392 0-7.964-3.572-7.964-7.963s3.572-7.964 7.963-7.964 7.962 3.573 7.962 7.964c0 4.39-3.57 7.963-7.962 7.963m0-17.227c-5.107 0-9.264 4.156-9.264 9.264s4.157 9.263 9.264 9.263c5.107 0 9.263-4.155 9.263-9.263s-4.156-9.264-9.263-9.264" />
      <path d="M18.581 25.05h1.301A4.122 4.122 0 0124 20.93v-1.299a5.424 5.424 0 00-5.418 5.417m15.517-12.428a1.767 1.767 0 10-.002 3.534 1.767 1.767 0 00.002-3.534" />
    </g>
  );

  return isHovered ? normalHover : normal;
};

export default Instagram;
